import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";

type ChecklistErrorStateProps = {
  message?: string;
};

export function ChecklistErrorState({
  message = "ບໍ່ພົບ Checklist",
}: ChecklistErrorStateProps) {
  return (
    <>
      <Header />
      <Main>
        <div className="flex items-center justify-center p-8">
          <p className="text-muted-foreground">{message}</p>
        </div>
      </Main>
    </>
  );
}
